<template>
  <div class="m-card-primary m-the-modal-content academy-billing-modal">
    <header class="m-the-modal-header">
      <h5>{{ $t('mEditionBillingAcademyBillingModalBuyers.title') }}</h5>
      <AtomButtonTheModalCloseIcon/>
    </header>
    <section class="m-the-modal-section academy-billing-modal-buyers">
      <p class="academy-billing-modal-products-subtitle">
        {{ element.nombreAcademia }}
        <small>{{ $t('mEditionBillingAcademyBillingModalBuyers.subtitle') }}</small>
      </p>

      <!-- Selector de divisa -->
      <div
        v-if="divisas.length > 1"
        class="academy-billing-modal-buyers-currencies"
      >
        <button
          v-for="(divisa, index) in divisas"
          :key="index"
          :class="divisaSeleccionada === divisa.id_divisa
            ? 'academy-billing-modal-buyers-currency academy-billing-modal-buyers-currency-active'
            : 'academy-billing-modal-buyers-currency'"
          type="button"
          @click="seleccionarDivisa(divisa.id_divisa)"
        >
          {{ divisa.divisa_iso_code }}
        </button>
      </div>

      <div
        v-if="showLoadingState"
        class="academy-billing-modal-buyers-loading"
      >
        <AtomLoadingSecondary/>
      </div>

      <template v-else>
        <ul v-if="compradores.length">
          <li
            v-for="(comprador, index) in compradores"
            :key="index"
            :class="index < 3 ? 'academy-billing-modal-buyers-top' : ''"
          >
            <span :class="positionClass(index)">
              <i
                v-if="index === 0"
                class="fas fa-trophy"
              ></i>
              <template v-else>{{ index + 1 }}</template>
            </span>
            <span class="display-flex-column academy-billing-modal-products-info">
              <span class="ellipsis font-weight-bold">{{ comprador.email }}</span>
              <small
                v-if="comprador.razon_social"
                class="ellipsis font-weight-regular"
              >
                {{ comprador.razon_social }}
              </small>
            </span>
            <span class="display-flex-column academy-billing-modal-buyers-amount">
              <span class="academy-billing-modal-buyers-total text-white-space-nowrap">
                {{ formatMoney(comprador.total, comprador.divisa_simbolo) }}
              </span>
              <small class="font-weight-regular text-white-space-nowrap">
                {{ comprador.cantidad_pagos }} {{ $t('mEditionBillingAcademyBillingModalBuyers.payments') }}
                · {{ comprador.cantidad_ventas }} {{ $t('mEditionBillingAcademyBillingModalBuyers.sales') }}
              </small>
            </span>
          </li>
        </ul>
        <p
          v-else
          class="text-align-center"
        >
          {{ $t('mEditionBillingAcademyBillingModalBuyers.noData') }}
        </p>

        <button
          v-if="hayMasPaginas"
          class="a-button-secondary a-button-billing-secondary academy-billing-modal-buyers-more"
          :disabled="loadingMore"
          type="button"
          @click="cargarMas"
        >
          <i class="fas fa-chevron-down margin-right-xsmall"></i>
          {{ $t('mEditionBillingAcademyBillingModalBuyers.loadMore') }}
        </button>
      </template>
    </section>
    <footer class="m-the-modal-footer">
      <AtomButtonTheModalCancelAction :cancel-text="$t('mEditionBillingAcademyBillingModalBuyers.close')"/>
    </footer>
  </div>
</template>

<script>
export default {
  name: 'MoleculeEditionBillingAcademyBillingModalBuyers',

  data () {
    return {
      compradores: [],
      divisaSeleccionada: '',

      element: {
        divisas: [],
        filtros: {},
        nombreAcademia: '',
        uuidAcademia: ''
      },

      loadingMore: false,
      pagina: 1,
      showLoadingState: true,
      totalPages: 0
    }
  },

  computed: {
    divisas () {
      return this.element.divisas || []
    },

    hayMasPaginas () {
      return this.pagina < this.totalPages
    }
  },

  created () {
    this.element = this.$modal.element
    if (this.divisas.length) {
      this.divisaSeleccionada = this.divisas[0].id_divisa
    }
    this.readCompradores()
  },

  methods: {
    buildFilter () {
      const filtros = {
        fecha_desde: this.element.filtros.fecha_desde || '',
        fecha_hasta: this.element.filtros.fecha_hasta || '',
        limite: 20,
        pagina: this.pagina,
        producto: this.element.filtros.producto || ''
      }

      if (this.divisaSeleccionada) {
        filtros.divisa = [this.divisaSeleccionada]
      }

      return filtros
    },

    cargarMas () {
      this.pagina += 1
      this.loadingMore = true
      this.readCompradores(true)
    },

    formatMoney (value, simbolo) {
      const amount = Number(value || 0).toLocaleString('es-AR', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      })
      return `${simbolo || ''} ${amount}`
    },

    positionClass (index) {
      const base = 'academy-billing-modal-buyers-position'
      if (index === 0) {
        return `${base} academy-billing-modal-buyers-position-gold`
      }
      if (index === 1) {
        return `${base} academy-billing-modal-buyers-position-silver`
      }
      if (index === 2) {
        return `${base} academy-billing-modal-buyers-position-bronze`
      }
      return base
    },

    readCompradores (append = false) {
      if (!append) {
        this.showLoadingState = true
      }
      this.$services.read('academiaIa', 'readFacturacionAcademiaCompradores', {}, [this.element.uuidAcademia], this.buildFilter())
        .then(response => {
          this.compradores = append
            ? this.compradores.concat(response.data.compradores)
            : response.data.compradores
          this.totalPages = response.data.pages
          this.showLoadingState = false
          this.loadingMore = false
        })
        .catch(error => {
          console.log(error)
          if (!append) {
            this.compradores = []
            this.totalPages = 0
          }
          this.showLoadingState = false
          this.loadingMore = false
          this.$alerts.pushAlert('mEditionBillingAcademyBillingModalBuyers', 'readCompradores', 'error', 'a-alert-danger')
        })
    },

    seleccionarDivisa (idDivisa) {
      if (this.divisaSeleccionada === idDivisa) {
        return
      }
      this.divisaSeleccionada = idDivisa
      this.pagina = 1
      this.readCompradores()
    }
  }
}
</script>
